import Link from 'next/link';
import React from 'react';
import { ArrowRightShort } from '../../assets/icons';
import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT } from '../../utils/posthogEvents';

/**
 * The shared "Start treatment" CTA. It reports its own click, so every place
 * it is used is tracked without each caller remembering to wire a handler —
 * `placement` just says which one it was. PostHog records the path alongside,
 * so an unlabelled instance is still attributable to its page.
 */
const StartTreatmentButton = ({
  styles = '',
  path = '/services#conditions',
  CTAtext = 'Start treatment',
  placement,
  onClick,
}) => {
  const handleClick = (event) => {
    captureEvent(PH_DIRECT.CLICK, {
      cta: PH_CTA.START_TREATMENT,
      ...(placement ? { placement } : {}),
    });
    onClick?.(event);
  };

  return (
    // The handler belongs on the div below, not on the <Link>. On Next 12's
    // legacy link behaviour (which this project uses, since newNextLinkBehavior
    // is not set) Link ignores its own onClick prop and only calls the one on
    // its direct child, so an onClick put on <Link> silently never runs.
    <Link href={path}>
      <div
        onClick={handleClick}
        className={`tw-p-[0.125rem] tw-rounded-full hero-home-new-cta tw-mt-2 ${styles}`}
      >
        <div className=' tw-bg-black tw-py-4 tw-px-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-gap-x-2 tw-cursor-pointer'>
          <span className='tw-font-medium tw-text-base tw-text-white'>
            {CTAtext}
          </span>

          <ArrowRightShort />
        </div>
      </div>
    </Link>
  );
};

export default StartTreatmentButton;
